const url = '/payment-methods';
const Provider = 'PaymentMethods';
const dbModel = 'PaymentMethods';

export { url, Provider, dbModel };
